import React from 'react';
import { classNames } from '../utils/formatters';
import { STATUS_STYLES } from '../utils/constants';

const StatusPill = ({ status }) => {
  const style = STATUS_STYLES[status] || { bg: 'bg-gray-100', text: 'text-gray-700', label: status };

  return (
    <span className={classNames('pill', style.bg, style.text, 'border border-transparent')}>
      {style.label || status}
    </span>
  );
};

export default StatusPill;
